import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RecentWinItem {
  game: 'rolls' | 'mines' | 'balloon';
  winner_id: string;
  winner_username: string;
  winner_avatar: string | null;
  payout: number;
  finished_at: string | null;
}

export interface FeedState {
  items: RecentWinItem[];
  loading: boolean;
  lastPlayedGame: string | null;
}

const LAST_PLAYED_KEY = 'last_played_game';

const initialState: FeedState = {
  items: [],
  loading: false,
  lastPlayedGame: localStorage.getItem(LAST_PLAYED_KEY),
};

const feedSlice = createSlice({
  name: 'feed',
  initialState,
  reducers: {
    fetchFeedRequest(state) {
      state.loading = true;
    },

    fetchFeedSuccess(state, action: PayloadAction<RecentWinItem[]>) {
      state.loading = false;
      state.items = action.payload;
    },

    fetchFeedFailure(state) {
      state.loading = false;
    },

    setLastPlayed(state, action: PayloadAction<string>) {
      state.lastPlayedGame = action.payload;
    },
  },
});

export const feedActions = feedSlice.actions;
export const feedReducer = feedSlice.reducer;
